import * as sessions from "../utils/sessions";

/* Intial State */
const initialState = {
    me: {},
    org: {},
};


/* Action Types */
const UPDATE_ME = "UPDATE_ME";
const UPDATE_ORG = "UPDATE_ORG";

/* Action Creators */
export const updateMe = (me) => {
    sessions.setSessionValue(sessions.PROFILE_KEY, me);
    return { type: UPDATE_ME, payload: me };
};
export const updateOrg = (org) => ({ type: UPDATE_ORG, payload: org });


/* Reducers */
export default (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
    case UPDATE_ME:
        return { ...state, me: payload };
    case UPDATE_ORG:
        return { ...state, org: payload };

    default:
        return state;
    }
};
